export default __webpack_public_path__ + "static/media/airlineLogo.de7ca1c6.png";